export const sanitizeText = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const textContains = (text: string, searchFor: string): boolean => {
  const sanitizedText = sanitizeText(searchFor);
  const checkExp = new RegExp(sanitizedText, 'gi');
  return checkExp.test(text);
};

export const seperateSplitsAndMatched = (text: string, matchText: string): { splits: string[]; matched: Array<string> } => {
  const sanitizedText = sanitizeText(matchText);
  const checkExp = new RegExp(sanitizedText, 'gi');
  const splits = text.split(checkExp);
  let matched: Array<string> = [];
  const allMatched = text.match(checkExp);
  if (allMatched?.length) {
    matched = allMatched;
  }
  return { splits, matched };
};

// used to show component Name in placeholder as text fallback
export const upperCaseWordSplitAndSpace = (text: string): string => {
  if (!text) return '';
  return text.split(/(?=[A-Z])/).join(' ');
};
